import React from 'react';

const Sidebar = () => {
  const menuItems = [
    { icon: "fas fa-home", label: "Home", active: false, className: "home" },
    { icon: "fas fa-chalkboard-teacher", label: "Tutors", active: true, className: "tutors" },
    { icon: "fas fa-book", label: "eBooks", active: false, className: "ebooks" },
    { icon: "fas fa-file-alt", label: "Papers", active: false, className: "papers" },
    { icon: "fas fa-sticky-note", label: "Notes", active: false, className: "notes" },
    { icon: "fas fa-university", label: "Admission", active: false, className: "admission" },
    { icon: "fas fa-poll", label: "Results", active: false, className: "results" }
  ];

  return (
    <aside className="sidebar">
      {menuItems.map((item, index) => (
        <a 
          key={index} 
          href="#" 
          className={`sidebar-icon ${item.className} ${item.active ? 'active' : ''}`}
        >
          <i className={item.icon}></i>
          <span>{item.label}</span>
        </a>
      ))}
    </aside>
  );
};

export default Sidebar;